export default __webpack_public_path__ + "static/media/kundalini.1fc98016.png";